import React from 'react';
import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';

const CheckboxSection = ({
  title,
  options,
  selectedValues,
  fieldName,
  otherFieldName,
  values,
  setFieldValue,
  handleChange,
}) => (
  <Card variant='outlined' sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant='h6' gutterBottom sx={{ mb: 2, fontWeight: 600 }}>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {options.map((opcao) => (
          <Grid item xs={12} sm={6} md={4} key={opcao}>
            <Card
              variant='outlined'
              sx={{
                cursor: 'pointer',
                transition: 'all 0.2s',
                border: selectedValues?.includes(opcao) ? 2 : 1,
                borderColor: selectedValues?.includes(opcao)
                  ? 'primary.main'
                  : 'divider',
                bgcolor: selectedValues?.includes(opcao)
                  ? 'primary.50'
                  : 'background.paper',
                '&:hover': {
                  borderColor: 'primary.main',
                  boxShadow: 1,
                },
              }}
              onClick={() => {
                const newValue = selectedValues?.includes(opcao)
                  ? selectedValues.filter((d) => d !== opcao)
                  : [...selectedValues, opcao];
                setFieldValue(fieldName, newValue);
              }}
            >
              <CardContent
                sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedValues?.includes(opcao)}
                      sx={{ py: 0 }}
                    />
                  }
                  label={opcao}
                  sx={{ m: 0, width: '100%' }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {selectedValues?.includes('Outra') ||
      selectedValues?.includes('Outro') ? (
        <JumboTextField
          fullWidth
          name={otherFieldName}
          label={`Especifique ${title.toLowerCase()}`}
          value={values[otherFieldName]}
          onChange={handleChange}
          sx={{ mt: 2 }}
        />
      ) : null}
    </CardContent>
  </Card>
);

export default CheckboxSection;
